var styles = {"box":"UserInfoWrapper_box_q7nha_1","top":"UserInfoWrapper_top_q7nha_7","bottom":"UserInfoWrapper_bottom_q7nha_13","buttons":"UserInfoWrapper_buttons_q7nha_18"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
